export enum DateTimeFormatLength {
  Full = 'full',
  Long = 'long',
  Medium = 'medium',
  Short = 'short',
}

export enum DatePartFormat {
  Numeric = 'numeric',
  TwoDigit = '2-digit',
  Long = 'long',
  Short = 'short',
  Narrow = 'narrow',
}
